import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";
import { getCheapestInsights } from "@/lib/cheapestPrices.functions";

const Billiga = lazy(() => import("@/pages/elavtal/Billiga"));

export const Route = createFileRoute("/elavtal/billiga")({
  loader: () => getCheapestInsights(),
  head: () =>
    seoHead("/elavtal/billiga", {
      description:
        "Hitta billigaste elavtalet för lägenhet, villa eller fritidshus i SE1–SE4. Preliminär topp 3 per elområde, rörligt eller fast pris – och sök på din adress.",
    }),
  component: BilligaRoute,
});

function BilligaRoute() {
  const insights = Route.useLoaderData();
  return <Billiga insights={insights ?? null} />;
}
